/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidLogic/ChallengeAuthorities/ClearBoardDailyPyramidAuthority',[
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/ChallengeConstants',
    'SolitaireShared/CardLogic/IClearBoardsAuthority',
    'SolitaireShared/PyramidLogic/IDailyPyramidAuthority'
], function (IDailyAuthority, ChallengeConstants, IClearBoardsAuthority, IDailyPyramidAuthority) {
    "use strict";

    var ClearBoardsDailyPyramidAuthority = function (param) {
        this.initClearBoardsDailyPyramidAuthority(param);
    };

    ClearBoardsDailyPyramidAuthority.constructor = ClearBoardsDailyPyramidAuthority;
    ClearBoardsDailyPyramidAuthority.prototype = Object.create(IDailyPyramidAuthority.prototype);
    IClearBoardsAuthority.call(ClearBoardsDailyPyramidAuthority.prototype);

    ClearBoardsDailyPyramidAuthority.prototype.initClearBoardsDailyPyramidAuthority = function (param) {
        IDailyPyramidAuthority.call(this, param);

        this.SuppressBonusAnimations = true;

        var isDirty = true;
        if (param != null && param[ChallengeConstants.KeyBoardsToClear])
        {
            this.BoardsToClear = parseInt(param[ChallengeConstants.KeyBoardsToClear]);
            isDirty = isNaN(this.BoardsToClear);
        }

        if (isDirty)
            throw "Invalid parameter passed in creating Daily Challenge";


        this.ChallengeType = IDailyAuthority.ChallengeType.ClearBoards;
    };


    ClearBoardsDailyPyramidAuthority.prototype.IsGameWon = function ()
    {
        if (this.CardSupply.WaitingForAnimation)
        {
            // We don't win unless the card animation is finished.
            return false;
        }

        if(this.CardSupply.IsWaitingForAds)
        {
            return false;
        }

        if (!this.CardSupply.IsGamePageLoaded)
        {
            return false;
        }

        if (this.CheckWin() && this.BoardsCompleted() < this.BoardsToClear)
        {
            this.Deal();
        }

        return (!this.CardSupply.WaitingForAnimation) && this.BoardsCompleted() >= this.BoardsToClear;
    };

    return ClearBoardsDailyPyramidAuthority;

});
